import magnifiAPIInstance from "./apiInstance";

export const packageAPIs = {
  createPackageName: ({ payload }) => magnifiAPIInstance.post("/package_name", payload),
};
